import { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useRedirect } from '@common/hooks/useRedirect';

const ImpersonatorAuthenticate = ({ isAuthenticated, countryCode }) => {
  const { redirect } = useRedirect();

  useEffect(() => {
    if (isAuthenticated) {
      redirect(`/${countryCode}/home`)();
      return;
    }

    redirect(`/${countryCode}/`)();
  }, [isAuthenticated, countryCode, redirect]);

  return <Fragment />;
};

ImpersonatorAuthenticate.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  countryCode: PropTypes.string.isRequired
};

export default connect(
  ({ auth, localisation }) => ({
    isAuthenticated: auth.isAuthenticated,
    countryCode: localisation.countryCode
  })
)(ImpersonatorAuthenticate);
